const styles = theme => ({
  root: {
    marginBottom: theme.spacing(3),
    width: '100%'
  },
  header: {},
  body: {}
});

export const panelFilterStyles = theme => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderLeft: `2px solid ${theme.palette.primary.main}`
  },
  header: {
    borderBottom: 'none'
  },
  body: {
    paddingTop: '8px'
  }
});

export default styles;
